module.exports = __webpack_public_path__ + "img/1289105880.10fcadb8.jpg";